import { useState, useEffect, useMemo, memo } from 'react';

// ═══════════════════════════════════════════
// 1. HOOK — coloca ISSO no componente da sua tabela
// ═══════════════════════════════════════════
export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export const LiveTime = memo(function LiveTime({ timestamp, now }) {
  
  const text = useMemo(() => {
    const sec = Math.floor((now - timestamp) / 1000);
    if (sec < 60) return `${sec} s`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} min`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} hr`;
    return `${Math.floor(hr / 24)} dia${Math.floor(hr / 24) > 1 ? "s": ""}`;
  }, [timestamp, now]);

  return <>{text}</>;
});